import { ArrowUpDown } from 'lucide-react';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "h-6 w-6" }) => {
  return (
    <div className={`relative ${className}`}>
      <ArrowUpDown className="text-white" />
    </div>
  );
};

export default Logo;